<template lang="html">
  <div
    :class="{ 'stage-slide--hidden': hidden }"
    class="stage-slide"
  >
    <Media
      v-bind="resource.columns.media"
      class="stage-slide__media"
    />
    <div class="stage-slide__content">
      <AppLink
        :is-link="targetProject && targetProject.url"
        :to="targetProject && targetProject.url || ''"
      >
        <Headline
          v-if="resource.columns.title"
          v-editable.text="resource.columns.title"
          :level="2"
          color="white"
          underlined
        />
      </AppLink>
      <p
        v-if="resource.columns.text"
        v-editable.text="resource.columns.text"
        class="stage-slide__paragraph"
      />
    </div>
    <AppLink
      v-if="resource.columns.hasVideo"
      :is-link="targetProject && targetProject.url"
      :to="targetProject && targetProject.url || ''"
      :class="`stage-slide__video-indicator--${colorClass}`"
      class="stage-slide__video-indicator"
    >
      <ImageEmpty
        v-if="resource.columns.title"
        :image-title="resource.columns.title"
      />
    </AppLink>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import { Resource } from 'beisheim/models'
import Media from 'beisheim/components/elements/media'
import Headline from 'beisheim/components/elements/headline'
import ImageEmpty from 'beisheim/components/elements/image-empty'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    Media,
    Headline,
    ImageEmpty,
    AppLink
  },
  mixins: [editable],
  data () {
    return {
      hidden: true
    }
  },
  computed: {
    colorClass () {
      return this.resource.columns.focus && this.resource.columns.focus.toLowerCase()
    },
    targetProject () {
      return Resource.find(this.resource.columns.projectSlug)
    }
  },
  mounted () {
    this.hidden = false
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/grid';
@import 'beisheim/scss/colors';
@import 'beisheim/scss/font';

$duration: 800ms;
$bezier: cubic-bezier(0,.57,.45,1);

.stage-slide {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &--hidden {
    .stage-slide__media {
      opacity: 0;
    }

    .headline, .stage-slide__paragraph {
      transform: translateY(50px);
      opacity: 0;
    }
  }

  &__media {
    position: relative;
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: opacity 300ms ease-in-out;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &:after {
      content: ' ';
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.45) 100%);
      z-index: 10;
    }
  }

  &__content {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #fff;
    @include grid-spacing(padding-right, 2);
    @include grid-spacing(padding-left, 2);
    padding-bottom: scale(10);
    max-width: 90%;
    z-index: 11;

    @include from(5) {
      padding-bottom: scale(16);
      max-width: 70%;
    }

    .headline {
      transition: transform $duration $bezier, opacity 350ms ease-in-out;
    }
  }

  &__paragraph {
    @include font(1);
    @include to(3) {
      display: none;
    }
    transition: transform $duration $bezier 50ms, opacity 350ms ease-in-out;
  }

  &__video-indicator {
      position: absolute;
      z-index: 20;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 1.5rem;
      right: 1.5rem;
      width: 3rem;
      height: 3rem;
      background: #000;
      transition: transform 400ms cubic-bezier(.24,0,.47,1);

      @include from(3) {
        bottom: 2.5rem;
        right: 2.5rem;
      }

      &--bildung {
        background-color: brand(3);
      }

      &--gesundheit {
        background-color: brand(4);
      }

      &--kultur {
        background-color: brand(1);
      }

      &--sport {
        background-color: brand(2);
      }

      &:before {
        content: '';
        position: relative;
        left: 0.1rem;
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 0 10px 17.3px;
        border-color: transparent transparent transparent #ffffff;
      }
    }
}
</style>
